module.exports = __webpack_public_path__ + "static/3.4d2124a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msc/3.png
// module id = 888
// module chunks = 144974278801183 275805287939862